module.exports = {
          srcSet: __webpack_public_path__ + "0d30310f7237d249e72907a3418b5dac-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "0d30310f7237d249e72907a3418b5dac-180.png",width: 180,height: 180}],
          src: __webpack_public_path__ + "0d30310f7237d249e72907a3418b5dac-180.png",
          toString:function(){return __webpack_public_path__ + "0d30310f7237d249e72907a3418b5dac-180.png"},
          
          width: 180,
          height: 180
        }